/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsDayFill: {
  name: 'day-fill';
  data: string;
} = {
  name: 'day-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1A.5.5 0 0 1 1 .5h14a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H1A.5.5 0 0 1 .5 3V1ZM1 4.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5H1Zm0 8a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5H1Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
